'use strict';

/**
 * Pict-Provider-TestRunAPI
 * ------------------------
 * Browser-side client for TestRun, extending the generic EntityAPI provider.
 * Adds start(): the one-call POST /1.0/TestRun/Start that creates the run plus
 * one TestRunStep per routine step (title/order snapshots) server-side. The
 * same call is the surface the planned browser plugin will drive. Closing the
 * run and editing its fields go through the generic update().
 */

const libPictProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'TestRunAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'TestRun',
	PluralRoute: 'TestRuns',
	IDField: 'IDTestRun'
};

class PictProviderTestRunAPI extends libPictProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
	}

	/**
	 * Start a run of a routine: creates the TestRun and its snapshot steps in
	 * one server call.
	 * @param {number|string} pIDRoutine - the routine to run
	 * @param {object} [pExtra] - optional { Name, Environment }
	 * @returns {Promise<object>} the created TestRun row
	 */
	start(pIDRoutine, pExtra)
	{
		let tmpBody = Object.assign({}, pExtra || {}, { IDRoutine: Number(pIDRoutine) || 0 });
		return libFrameworkClient.postJSON(this.fable, this._url('TestRun/Start'), tmpBody)
			.then((pBody) => (pBody && pBody.TestRun) ? pBody.TestRun : pBody);
	}
}

module.exports = PictProviderTestRunAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
